import axios, { AxiosError } from 'axios';

// services
import { ErrorResponse, ProcessFailure, ProcessResult, ProcessSuccess } from '../../../utils/handleError';

// config
import { DASHBOARD_API_BASE_URL } from '../../../config/env';

/**
 * 帳票イメージをアップロード
 * - 帳票イメージをアップロードするための署名付きURLを取得
 * - 署名付きURLを使ってアップロード
 */
export const uploadSourceFile = async (
  file: File,
  templateId: string,
  accessToken: string,
  onUploadProgress: (percent: number) => void
): Promise<ProcessResult<boolean, ErrorResponse>> => {
  try {
    // 署名付きURLを取得
    const getSignedUrlResponse = await axios.post<{
      url: string;
    }>(
      `${DASHBOARD_API_BASE_URL}/sources/${templateId}/get-upload-url`,
      {
        file_name: file.name,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'content-type': 'application/json',
        },
      }
    );

    // file.typeが空の場合はapplication/octet-stream（ファイル形式不明時のデフォルト値）を設定
    // - 一部ブラウザでは特定ファイル形式のFile.typeが空文字列になる
    // - S3へのアップロードではContent-Typeヘッダーが必須
    const contentType = file.type || 'application/octet-stream';
    console.debug('Upload Content-Type:', contentType);
    // 署名付きURLを使ってアップロード
    await axios.put(getSignedUrlResponse.data.url, file, {
      headers: {
        'Content-Type': contentType,
      },
      // アップロード進捗を取得し、ローディング表示に利用する
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onUploadProgress(percentCompleted);
        }
      },
    });

    return new ProcessSuccess(true);
  } catch (err) {
    const axiosError = err as AxiosError;
    return new ProcessFailure(
      new ErrorResponse(uploadSourceFile.name, axiosError.response?.status, 'UPLOAD_SOURCE_FILE_ERROR', axiosError)
    );
  }
};
